import { createApp } from 'vue'
import elementPlus from './plugins/elementPlus.js'
import App from './App.vue'
import router from './router/index.js'
import axios from './plugins/axios.js'
import cookie from './plugins/cookie'
import * as ElIcons from '@element-plus/icons-vue'



const app = createApp(App);
app.use(elementPlus)
app.use(cookie);
app.use(router);
app.use(axios);
app.mount('#app');

for (const name in ElIcons) {
    app.component(name, ElIcons[name])
}